import React from 'react'
import search from '../assets/images/search_black.png';
import { useDispatch, useSelector } from "react-redux";

export default function SearchBox(props) {
    const dispatch = useDispatch();
    const plantName = useSelector((state) => state.allPlants.plantName);
    // console.log("Probs filterStatus+>",props.filterStatus);

    function handle(value) {
        console.log("inside handle = ", value)
    }

   

    return (
        <>
            <div className='vehicle-header-util'>
                <div className="vehicle-header-search-form">
                    <input type="submit" value="" onClick={() => handle("dd")} className="vehicle-header-search-submit" />
                    <input type="search" ref={props.formRef} name="searchName" id="searchName" onChange={(e) => props.handleSearch(e.target.value)} className="vehicle-header-search-text" placeholder={"Search "+props.inputSearchPlaceholder} autoComplete="off" />
                </div>
            </div>
            <style jsx="true">
                {`
                    input.vehicle-header-search-text {
                        background: url(${search}) no-repeat right 5px center transparent;
                        background-size: 20px;
                    }

                    /*For smaller screens below 1440px width */
                    @media screen and (max-width: 1440px) {
                        input.vehicle-header-search-text {
                            background-size: 16px;
                        }
                    }
    
            `}
            </style>
        </>
    )
}
